import { defineStore } from 'pinia'
import type { DossierDTO } from '@/features/api/extranet/dto/Dossier/Synthese'
import type { LovDossierDTO } from '@/features/api/extranet/dto/Dossier/Synthese/LovDossierDTO'
import { shallowRef } from 'vue'
import * as services from '@/features/services/detail/dossier/DossierService'

export const useDossierStore = defineStore('dossier', () => {
  const model = shallowRef<DossierDTO>()
  const lov = shallowRef<LovDossierDTO>()

  async function loadData(code: string) {
    lov.value = await services.loadDossierLov()
    model.value = await services.loadDossier(code)
  }

  function $reset() {
    model.value = undefined
    lov.value = undefined
  }

  return {
    lov,
    model,
    loadData,
    $reset
  }
})
